export default __webpack_public_path__ + "static/media/image5.3773e2b3.jpg";